import DeviceScreenPreview, { emojiFromEmotion } from '../../../../components/DeviceScreenPreview'
import { Modal } from '../../../../components/Modal'
import { Button } from '../../../../components/ui/Button'
import { emotionLabelEntry, normalizeEmotion } from '../../../../utils/emotion'
import { LIBRARY_FAMILY_LABELS, ossGroupDisplayName, shortenTag } from './eyesPreviewData'

export function EyesDetailsModal(props) {
  const { detailsProduct, setDetailsKey, setDetailsSubKey, detailsActiveGroup, tx,
    openCompareFromModal, poke, accent } = props
  return (
    <>
      <Modal
        open={Boolean(detailsProduct)}
        onClose={() => {
          setDetailsKey(null)
          setDetailsSubKey(null)
        }}
        title={
          (() => {
            if (!detailsProduct) return ''
            const familyLabel = LIBRARY_FAMILY_LABELS[detailsProduct.key]
            if (familyLabel && detailsActiveGroup && detailsProduct.groups.length > 1) {
              return `${tx(familyLabel)} · ${shortenTag(ossGroupDisplayName(detailsActiveGroup), 24)}`
            }
            return tx(familyLabel || ossGroupDisplayName(detailsActiveGroup))
          })()
        }
        footer={
          detailsProduct ? (
            <>
              <Button
                onClick={() => {
                  setDetailsKey(null)
                  setDetailsSubKey(null)
                }}
                variant="neutral"
              >
                {tx({ zh: '关闭', en: 'Close' })}
              </Button>
              <Button onClick={openCompareFromModal} variant="secondary">
                {tx({ zh: '打开对比视图', en: 'Open compare view' })}
              </Button>
            </>
          ) : null
        }
      >
        {detailsProduct && detailsActiveGroup ? (
          <div className="space-y-4">
            <div className="text-sm font-extrabold text-brand-textDark/80 dark:text-slate-200">
              <span className="px-2 py-1 rounded-full bg-brand-yellow/60 border-2 border-brand-textDark/10 text-brand-textDark">
                {tx(themeLabelById.get(detailsActiveGroup.theme) || detailsActiveGroup.theme)}
              </span>
              <span className="ml-2 text-brand-text dark:text-slate-300">
                {detailsActiveGroup.variant ? detailsActiveGroup.variant : 'default'}
              </span>
            </div>

            <div className="rounded-3xl border-2 border-brand-textDark/10 bg-brand-bg p-4 dark:bg-slate-900 dark:border-slate-800">
              <div className="flex justify-center">
                <div style={{ transform: `scale(${Math.max(0.75, cardScale)})`, transformOrigin: 'top center' }}>
                  <DeviceScreenPreview
                    theme={detailsActiveGroup.theme}
                    variant={detailsActiveGroup.variant || undefined}
                    emotion={libraryEmotion}
                    accent={accent}
                    poke={poke}
                    contentOnly
                  />
                </div>
              </div>
            </div>

            {detailsProduct.groups.length > 1 ? (
              <div className="flex flex-wrap items-center gap-2">
                <span className="text-xs font-extrabold text-brand-text dark:text-slate-300">{tx({ zh: '子样式', en: 'Styles' })}</span>
                {detailsProduct.groups.map((g) => {
                  const k = ossGroupKey(g)
                  const active = k === ossGroupKey(detailsActiveGroup)
                  const name = shortenTag(ossGroupDisplayName(g), 20)
                  return (
                    <button
                      key={k}
                      type="button"
                      onClick={() => {
                        setDetailsSubKey(k)
                        selectOssGroup(g)
                      }}
                      className={`px-3 py-2 rounded-2xl text-xs font-extrabold border-2 transition-colors ${
                        active
                          ? 'bg-brand-yellow text-brand-textDark border-brand-textDark/20 dark:bg-brand-yellow dark:text-brand-textDark'
                          : 'bg-white text-brand-text border-brand-textDark/10 hover:bg-brand-bg hover:text-brand-textDark dark:bg-slate-950 dark:text-slate-300 dark:border-slate-800 dark:hover:bg-slate-900 dark:hover:text-slate-100'
                      }`}
                      title={ossGroupDisplayName(g)}
                    >
                      {name}
                    </button>
                  )
                })}
              </div>
            ) : null}

            <div className="flex flex-wrap items-center gap-2">
              <span className="text-xs font-extrabold text-brand-text dark:text-slate-300">{tx({ zh: '心情', en: 'Mood' })}</span>
              {['neutral', 'happy', 'angry', 'sleepy', 'surprised', 'confused'].map((m) => {
                const active = normalizeEmotion(libraryEmotion) === normalizeEmotion(m)
                return (
                  <button
                    key={m}
                    type="button"
                    onClick={() => updateLibraryEmotion(m)}
                    className={`px-3 py-2 rounded-2xl text-xs font-extrabold border-2 transition-colors ${
                      active
                        ? 'bg-brand-yellow text-brand-textDark border-brand-textDark/20 dark:bg-brand-yellow dark:text-brand-textDark'
                        : 'bg-white text-brand-text border-brand-textDark/10 hover:bg-brand-bg hover:text-brand-textDark dark:bg-slate-950 dark:text-slate-300 dark:border-slate-800 dark:hover:bg-slate-900 dark:hover:text-slate-100'
                    }`}
                  >
                    <span className="mr-1">{emojiFromEmotion(m)}</span>
                    {tx(emotionLabelEntry(m))}
                  </button>
                )
              })}
            </div>

            <div className="space-y-2">
              <div className="text-xs font-extrabold text-brand-text dark:text-slate-300">{tx({ zh: '相关仓库（同组）', en: 'Related repos (grouped)' })}</div>
              <div className="grid grid-cols-1 gap-2">
                {detailsProduct.groups.map((g) => {
                  const tag = ossGroupDisplayName(g)
                  return (
                    <div key={ossGroupKey(g)} className="rounded-2xl border-2 border-brand-textDark/10 bg-white overflow-hidden dark:bg-slate-950 dark:border-slate-800">
                      {detailsProduct.groups.length > 1 ? (
                        <div className="px-4 py-2 bg-brand-bg border-b border-brand-textDark/10 text-[11px] font-black text-brand-textDark dark:bg-slate-900 dark:border-slate-800 dark:text-slate-300">
                          {tag}
                        </div>
                      ) : null}
                      <div className="p-2 space-y-2">
                        {(g.projects || []).map((p) => (
                          <a
                            key={p.id}
                            href={p.repo}
                            target="_blank"
                            rel="noreferrer"
                            className="block rounded-2xl border-2 border-brand-textDark/10 bg-white hover:bg-brand-bg px-4 py-3 transition-colors dark:bg-slate-950 dark:border-slate-800 dark:hover:bg-slate-900"
                          >
                            <div className="text-sm font-extrabold text-brand-textDark dark:text-slate-100 truncate">{p.label}</div>
                            <div className="text-[11px] font-bold text-brand-text dark:text-slate-400 break-all">{p.repo}</div>
                          </a>
                        ))}
                      </div>
                    </div>
                  )
                })}
              </div>
            </div>
          </div>
        ) : null}
      </Modal>
    </>
  )
}
